import {Block, Button} from "../../components/";

const text = "Ты прошёл все этапы, а значит осталось нажать на кнопку «участвовать» и ждать результатов.";

export const SberSecondBlock = ({finished}) => {
    return (
        <Block name="box-blue-12" title="Ура!" desc={text}>
            <Button className="finish-button" text="Участвовать" handler={finished}/>
        </Block>
    )
}